module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "breakouts shrinker"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.timeslots), function(timeslot) {
    return _c('div', {
      staticClass: "col-medium-1-4"
    }, [_c('div', {
      staticClass: "timeslot-card",
      class: {
        'timeslot-card--workshop': timeslot.type == 'workshop', 'timeslot-card--breakout': timeslot.type == 'breakout'
      },
      on: {
        "click": function($event) {
          _vm.setTimeslot(timeslot)
        }
      }
    }, [_c('div', {
      staticClass: "timeslot-card__name"
    }, [_vm._v("\n                        " + _vm._s(timeslot.name) + "\n                    ")]), _vm._v(" "), _c('div', {
      staticClass: "timeslot-card__time"
    }, [_vm._v("\n                        " + _vm._s(_vm.timeTopLine(timeslot)) + "\n                        "), _c('br'), _vm._v("\n                        " + _vm._s(_vm.timeBottomLine(timeslot)) + "\n                    ")])])])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f1fac43","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./source/js/components/Timeslots.vue
// module id = 75
// module chunks = 1